import { render, staticRenderFns } from "./FieldsFieldtype.vue?vue&type=template&id=6e65ce14&"
import script from "./FieldsFieldtype.vue?vue&type=script&lang=js&"
export * from "./FieldsFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports